import { Segment, Grid, Divider, Header, Icon, Radio } from 'semantic-ui-react'

import { DeliveryOption } from '../../../types/RM'

const DeliveryPicker = ({
  value,
  onChange,
}: {
  value: DeliveryOption
  onChange: (pref: DeliveryOption) => any
}) => {
  return (
    <Segment>
      <Grid columns={2} textAlign="center">
        <Divider vertical>Or</Divider>

        <Grid.Row verticalAlign="middle">
          <Grid.Column
            onClick={() => onChange('email')}
            style={{
              cursor: 'pointer',
            }}
          >
            <Header icon>
              <Icon name="mail outline" />
              Email
            </Header>
            <div>
              <Radio checked={value === 'email'} />
            </div>
          </Grid.Column>

          <Grid.Column
            onClick={() => onChange('sms')}
            style={{
              cursor: 'pointer',
            }}
          >
            <Header icon>
              <Icon name="mobile" />
              SMS / Text
            </Header>
            <div>
              <Radio checked={value === 'sms'} />
            </div>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Segment>
  )
}

export default DeliveryPicker
